module.exports = __webpack_public_path__ + "static/media/19-5.f2ff5130.mp3";